<template>
  <section class="hero is-fullheight">
    <div class="hero-body">

      <div class="container">
        <figure class="image center">

          <img src="../../static/rocket.png" style="max-width: 128px;">
          <div class="title">
            <router-link to="/app">
              <a>RocketSchool</a>
            </router-link>
          </div>
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home.vue